import { Params } from '@angular/router';

export const noneUndefined = (obj: Params) => {
  Object.keys(obj).forEach(key => {
    if (obj[key] === undefined) {
      delete obj[key];
    }
  });
  return obj;
};
